// item_id/orders_id are aliases for _id produced by some backend aggregation
// pipelines, not independent identifiers — kept in the fallback chain for
// forward-compatibility with pipelines that do expose a real publicId there.
export const getPublicIdentifier = (item, fallback = "") =>
  item?.publicId || item?.item_id || item?._id || item?.id || fallback || "";

export const buildShopSellerPath = (sellerOrOwner, fallbackOwnerId = "", query = "") => {
  const sellerId = getPublicIdentifier(sellerOrOwner, fallbackOwnerId);
  if (!sellerId) return "/";

  const base = `/lakay-ShopSeller/${sellerId}`;
  return query ? `${base}${query}` : base;
};

export const buildShopSellerAboutPath = (sellerOrOwner, fallbackOwnerId = "") => {
  const sellerId = getPublicIdentifier(sellerOrOwner, fallbackOwnerId);
  return sellerId ? `/lakay-ShopSeller/${sellerId}/about` : "/";
};

// Product documents don't actually carry a `productID`/`item_id` field today —
// those are aggregation-alias names used elsewhere (cart/order line items,
// category matrices). Kept in the chain so this stays correct if a caller
// passes one of those shapes instead of a raw Product document.
export const getProductEditId = (product, fallback = "") =>
  product?.publicId || product?.productID || product?.item_id || product?._id || fallback || "";

export const buildProductEditPath = (product, fallback = "") => {
  const id = getProductEditId(product, fallback);
  return id ? `/product/edit/${id}` : "/";
};
